import { useTranslation } from 'react-i18next'
import { ClickAwayListener, Popper } from '@material-ui/core'

import styles from '../DonationsFiltersAndActions.module.scss'

import { Button } from '@percent/lemonade'
import { DownloadDonationsExportProps } from './DownloadDonationsExport.types'

export function DownloadDonationsExport({
  open,
  setOpen,
  anchorEl,
  isDownloadInProgress,
  handleDownloadReassignmentsCsv,
  handleOpenPayrollDeductionsModal,
  canReassign
}: DownloadDonationsExportProps) {
  const { t } = useTranslation()

  return (
    <Popper open={open} anchorEl={anchorEl} placement="bottom-end">
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div className={styles.dropdownContainer}>
          <Button
            size="small"
            variant="secondary"
            onClick={handleDownloadReassignmentsCsv}
            disabled={!canReassign || isDownloadInProgress}
            loading={isDownloadInProgress}
          >
            {t('button.exportReassignmentList')}
          </Button>
          <Button
            size="small"
            variant="secondary"
            onClick={() => {
              setOpen(false)
              handleOpenPayrollDeductionsModal()
            }}
          >
            {t('button.pendingPayrollDeductions')}
          </Button>
        </div>
      </ClickAwayListener>
    </Popper>
  )
}
